import { Component } from '@angular/core';

@Component({
    selector: 'app-user-disabled',
    templateUrl: './user-disabled.component.html',
    styleUrls: ['./user-disabled.component.scss'],
    standalone: false
})
export class UserDisabledComponent {}
